export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StoryCard.vue?vue&type=template&id=3b38e16e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/StoryCard.vue?vue&type=template&id=3b38e16e&
// module id = 1041
// module chunks = 0